import ActionTypes from "../../../constants/ActionTypes";
import {
  INotification,
  IClearNotificationsAction,
  IRemoveNotificationAction,
  ISetNotificationAction,
} from "./types";

export const getNotification = (flashMessages: INotification[], entity: string) => ({
  type: `${entity} ${ActionTypes.NOTIFICATION.GET}`,
  payload: { flashMessages },
  meta: { entity }
});

export const setNotification = (notifications: INotification[], entity: string): ISetNotificationAction => ({
  type: `${entity} ${ActionTypes.NOTIFICATION.SET}`,
  payload: { notifications },
  meta: { entity }
});

export const removeNotification = (notificationId: string | number): IRemoveNotificationAction => ({
  type: ActionTypes.NOTIFICATION.REMOVE,
  payload: { notificationId },
});

export const clearNotifications = (): IClearNotificationsAction => ({
  type: ActionTypes.NOTIFICATION.CLEAR
});

export const createErrorNotification = (errorResponse: any, entity: string) => ({
  type: ActionTypes.NOTIFICATION.CREATE_ERROR,
  payload: { errorResponse },
  meta: { entity }
});

export const validateNotification = (errorResponse: any, entity: string) => ({
  type: ActionTypes.NOTIFICATION.VALIDATE_NOTIFICATION,
  payload: { errorResponse },
  meta: { entity }
});
